// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"eff18850","234":"59763e44","387":"a3349c86","388":"80ab4045","787":"c65a89d1","860":"6785fee4"}[chunkId] + ".chunk.js";
};